import { createAsyncThunk } from "@reduxjs/toolkit";
import localhost from "apis/localhost";
import createExportThunk from "slices/captureDashboard/createExportThunk";
import { selectFilters } from "slices/captureDashboard/selectors";
import { resolvePeriod } from "utils/reportingPeriod";

const BASE_URL = "/api/capture-dashboard/widgets/pipeline-by-owner";
const LIMIT = 5;
const CSV_FILENAME = "Pipeline by Owner.csv";
const PDF_FILENAME = "Pipeline by Owner.pdf";

export const fetchPipelineByOwner = createAsyncThunk(
  "pipelineByOwner/fetch",
  async (_, { getState }) => {
    const filters = selectFilters(getState());
    const { periodStart, periodEnd } = resolvePeriod(filters);

    const { data } = await localhost.get(BASE_URL, {
      params: { periodStart, periodEnd, limit: LIMIT },
    });
    return data;
  },
);

export const exportPipelineByOwnerCsv = createExportThunk(BASE_URL, "csv", CSV_FILENAME);
export const exportPipelineByOwnerPdf = createExportThunk(BASE_URL, "pdf", PDF_FILENAME);
